import VideoCard from './VideoCard';
import { VideoItem } from '../../../mocks/videos';

interface VideoGridProps {
  videos: VideoItem[];
}

export default function VideoGrid({ videos }: VideoGridProps) {
  return (
    <div className="grid grid-cols-1 md:grid-cols-2 lg:grid-cols-3 gap-6">
      {videos.map((video) => (
        <div
          key={video.id}
          className={video.featured ? 'lg:col-span-2' : ''}
        >
          <VideoCard video={video} />
        </div>
      ))}
    </div>
  );
}
